import DataService from "domain/data/dataService";

export const getServerSideProps = async () => {
  const service = new DataService();
  const dataListMessageSSR = await service.getListMetaUSCISStatusMessage();

  return {
    redirect: {
      destination: `/data/uscis-status-explorer/${dataListMessageSSR[0].urlSlug}?caseType=${dataListMessageSSR[0].defaultCaseType}&caseCategory=${dataListMessageSSR[0].defaultCaseCategory}`,
      permanent: false,
    },
  };
};

export default () => null;
